/**
 * PostProcessing — CSS-based visual effects overlay.
 * - Vignette (subtle darkening at edges)
 * - Biome color grading (warm desert, cool tundra)
 * - Night blend mode
 */
export class PostProcessing {
  constructor() {
    this._overlay = document.createElement('div');
    this._overlay.style.cssText = `
      position:fixed; top:0; left:0; width:100%; height:100%;
      pointer-events:none; z-index:50;
      background: radial-gradient(ellipse at center, transparent 60%, rgba(0,0,0,0.25) 100%);
      transition: background 2s ease, mix-blend-mode 1s ease;
    `;
    document.body.appendChild(this._overlay);
    this._currentBiome = 'plains';
  }

  setBiome(biome) {
    if (biome === this._currentBiome) return;
    this._currentBiome = biome;
    switch (biome) {
      case 'desert':
        this._overlay.style.background =
          'radial-gradient(ellipse at center, rgba(255,200,100,0.05) 40%, rgba(0,0,0,0.3) 100%)';
        break;
      case 'tundra':
        this._overlay.style.background =
          'radial-gradient(ellipse at center, rgba(150,200,255,0.05) 40%, rgba(0,0,0,0.35) 100%)';
        break;
      case 'jungle':
        this._overlay.style.background =
          'radial-gradient(ellipse at center, rgba(100,200,50,0.03) 40%, rgba(0,0,0,0.3) 100%)';
        break;
      case 'swamp':
        this._overlay.style.background =
          'radial-gradient(ellipse at center, rgba(80,120,40,0.04) 40%, rgba(0,0,0,0.35) 100%)';
        break;
      case 'nether':
        this._overlay.style.background =
          'radial-gradient(ellipse at center, rgba(255,50,0,0.08) 30%, rgba(0,0,0,0.5) 100%)';
        break;
      case 'end':
        this._overlay.style.background =
          'radial-gradient(ellipse at center, rgba(100,0,200,0.06) 30%, rgba(0,0,0,0.5) 100%)';
        break;
      default:
        this._overlay.style.background =
          'radial-gradient(ellipse at center, transparent 60%, rgba(0,0,0,0.25) 100%)';
    }
  }

  setNight(isNight) {
    if (isNight) {
      this._overlay.style.mixBlendMode = 'multiply';
    } else {
      this._overlay.style.mixBlendMode = '';
    }
  }

  hide() { this._overlay.style.display = 'none'; }
  show() { this._overlay.style.display = ''; }
}
